<template>
  <div class="thenRow pa-1 d-flex align-center flex-wrap">
    <v-menu
      offset-y
      offset-x
      :disabled="$vuetify.breakpoint.mdAndUp"
      rounded="lg"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-chip
          v-bind="attrs"
          v-on="on"
          outlined
          pill
          :color="thenTypes[rowType].color"
          class="me-2 py-5 pe-4 d-flex justify-center align-center"
          style="min-width: 150px"
          v-if="rowType"
        >
          <v-icon :color="thenTypes[rowType].color" class="me-2">
            {{ thenTypes[rowType].icon }}
          </v-icon>
          {{ thenTypes[rowType].title }}
        </v-chip>
      </template>
      <v-list>
        <v-list-item>
          <v-list-item-title class="px-3 text-wrap w-100">{{
            getText()
          }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <div
      v-if="$vuetify.breakpoint.mdAndUp"
      class="grey--text text--darken-2 ifRowText"
    >
      {{ getText() }}
    </div>
  </div>
</template>
<script>
export default {
  name: "ThenRowContent",
  props: {
    thenRow: {
      type: Object,
      required: true,
    },
  },
  computed: {
    rowType() {
      if ("then_notify" in this.thenRow) {
        return "then_notify";
      } else if ("then_controller" in this.thenRow) {
        return "then_controller";
      }
      return null;
    },
    devices() {
      const devices = this.$store.getters["devices/devices"];
      return Object.values(devices);
    },
  },
  created() {
    this.thenTypes = {
      then_notify: {
        title: this.$t("notification"),
        icon: "mdi-bell-outline",
        color: "blue",
      },
      then_controller: {
        title: this.$t("controller_action"),
        icon: "mdi-chip",
        color: "green",
      },
    };
  },
  methods: {
    device(identifier) {
      return this.devices && identifier
        ? this.devices.filter((d) => d.identifier == identifier)[0]
        : null;
    },
    getText() {
      let text = "";
      //   console.log("then_notify", this.thenRow.then_notify.not);
      if ("then_notify" in this.thenRow) {
        text = this.$t("sendMsg") + " " + this.$t("via") + " ";
        text += this.thenRow.then_notify.not
          .map((channel) => {
            return this.$t(channel == "email" ? "emailNot" : channel);
          })
          .join(", ");
      } else if ("then_controller" in this.thenRow) {
        const device = this.device(this.thenRow.then_controller);

        // console.log("then_controller", this.thenRow.then_controller, device);
        text = device && device.name ? device.name : device.identifier;
        text += " - " + this.$t(this.thenRow.then_action);
      }
      return text;
    },
  },
};
</script>
<style lang="scss" scoped>
.ifRowText {
  line-height: 1.1;
}
</style>
